export interface Pageable<T> {
  content: T[];
  totalPages: number;
  totalElements: number;
  first: boolean;
  last: boolean;
  empty: boolean;
  size: number;
  number: number;
  numberOfElements:number;
}

export class EmptyPage<T> implements Pageable<T> {
  content;
  totalElements;
  totalPages;
  first;
  last;
  empty;
  size;
  number;
  numberOfElements;
  constructor() {
    this.content = [];
    this.empty = true;
    this.totalElements = 0;
    this.totalPages = 0;
    this.first = false;
    this.last = false;
  }
}
